export const SHOW_MODAL = 'SHOW_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';

export const showSubmitMod = () => ({
      type: SHOW_MODAL,
      payload:{modValue:true}    
})

export const closeSubmitMod = () => ({
     type: CLOSE_MODAL,
     payload:{modValue:false} 
})

